import { render, staticRenderFns } from "./addProduct.vue?vue&type=template&id=718b8e46"
import script from "./addProduct.vue?vue&type=script&lang=js"
export * from "./addProduct.vue?vue&type=script&lang=js"
import style0 from "./addProduct.vue?vue&type=style&index=0&id=718b8e46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports